var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1837 9.55396L17.0043 14.6695C16.4386 15.1307 15.7405 15.3814 15.0216 15.3814C14.3028 15.3814 13.6047 15.1307 13.039 14.6695L6.87402 9.55396",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16168 1.12842H21.8086C22.7842 1.14496 23.7464 1.36645 24.6376 1.7796C25.5287 2.19274 26.3303 2.78897 26.994 3.53248C27.6578 4.27598 28.1701 5.15141 28.5001 6.10605C28.8301 7.06069 28.9709 8.07485 28.9142 9.08755V18.9123C28.9719 19.9273 28.831 20.944 28.5002 21.9008C28.1694 22.8576 27.6555 23.7347 26.9894 24.4792C26.3295 25.2256 25.5291 25.8231 24.6379 26.2346C23.7467 26.6461 22.7837 26.8629 21.8086 26.8715H8.16168C3.93592 26.8715 1.08496 23.3057 1.08496 18.9274V9.10261C1.08496 4.70927 3.97934 1.12842 8.16168 1.12842Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/mail_outline.43fdbbf67d8e115b7b6fa4059c9f8717.svg";
export { ForwardRef as ReactComponent };